"use strict";
/* tslint:disable */
var TCombinatorSPSlipMode = (function () {
    "use strict";
    var api = {};
    // Overrides ComboSPSlipMode
    api.updateView = function () {
        TUniSlip.buildView();
    };
    // Template logic splitter
    api.buildOptions = function (selections) {
        /*globals Modes */
        Modes.calcComboVariants(this);
        /*globals TMultiOptions */
        return TMultiOptions.buildCombo(this, selections);
    };
    // Adapter for Array.push template implementation
    api.buildSelectionInnerView = function (selection, selectionUpdated) {
        return TBuildLine.buildInnerView(selection, this, { buildInner: true, updated: selectionUpdated, isSP: true });
    };
    api.showDifferentTypesPopup = function () {
        // @ts-ignore: skip type checking on functions declared in javascript
        UI.message.show({
            header: $dict.bs("ErrorGeneral"),
            body: $dict.bs("BetsWithDifferentTypesNotAllowed"),
            actions: {
                cancel: { text: $string("General").Close }
            }
        });
    };
    api.buildHeader = function () {
        return "";
    };
    return api;
}());
window.TCombinatorSPSlipMode = TCombinatorSPSlipMode;
//# sourceMappingURL=TCombinatorSPSlipMode.js.map